import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import AppleState from '../../types/AppleState'

const getters: GetterTree<AppleState, RootState> = {}

export default getters
